<template>
  <div id="app">
    <router-view/>
    <div v-if="!isMobile()">
      <video ref="video" autoplay muted loop>
        <source src="/ARK_ GenesisP2.mp4" type="video/mp4">
      </video>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [{
        date: '售价',
        three: '28￥',
        weekend: '48￥',
        halfmonth: '68￥',
        month: '88￥'
      }, {
        date: '获得金币',
        three: '24.8W',
        weekend: '45.4W',
        halfmonth: '72.4W',
        month: '115.4W'
      },]
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  }
}
</script>
<style>
video {
  margin: 0px auto;
  position: fixed;
  top: 50%;
  left: 50%;
  visibility: visible;
  opacity: 1;
  min-width: 100%;
  min-height: 100%;
  z-index: -9999;
  -webkit-transform: translate(-50%, -50%);
  -webkit-transition: 1s opacity;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
